export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.maintenance_choice) {
        return {...state, ...payload.maintenance_choice};
      }
      return state;
    }
  }
};
